export const selectWsConnection = state => state.websocket.connected;
export const selectWsMessage = state => state.websocket.message;
